module.exports = {"id":"235875","name":"Pol Lirola","rating":"74","photo":"./data/images/photos/0/235875.png","club":{"name":"Sassuolo","logo":"./data/images/clubs/Sassuolo.png"},"positions":["DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PolLirola0.json
// module id = 3476
// module chunks = 0